export default __webpack_public_path__ + "static/stats_3_ru-c4b89e9891dec1b8efe15e8adf325cae.png";